"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

function handleGeneratorFunctionIssue(options) {
  var e = options.e,
      name = options.name;
  var msg = '';

  if (name) {
    var lastLine = 'A generator function takes a single arg of props (and the location for react-router) ' + 'and returns a ReactElement.';
    var shouldBeGeneratorError = "ERROR: ReactOnRails is incorrectly detecting generator function to be false. The React\ncomponent '".concat(name, "' seems to be a generator function.\n").concat(lastLine);
    var reMatchShouldBeGeneratorError = /Can't add property context, object is not extensible/;

    if (reMatchShouldBeGeneratorError.test(e.message)) {
      msg += "".concat(shouldBeGeneratorError, "\n\n");
      console.error(shouldBeGeneratorError);
    }

    shouldBeGeneratorError = "ERROR: ReactOnRails is incorrectly detecting generatorFunction to be true, but the React\ncomponent '".concat(name, "' is not a generator function.\n").concat(lastLine);
    var reMatchShouldNotBeGeneratorError = /Cannot call a class as a function/;

    if (reMatchShouldNotBeGeneratorError.test(e.message)) {
      msg += "".concat(shouldBeGeneratorError, "\n\n");
      console.error(shouldBeGeneratorError);
    }
  }

  return msg;
}

var handleError = function handleError(options) {
  var e = options.e,
      jsCode = options.jsCode,
      serverSide = options.serverSide;
  console.error('Exception in rendering!');
  var msg = handleGeneratorFunctionIssue(options);

  if (jsCode) {
    console.error("JS code was: ".concat(jsCode));
  }

  if (e.fileName) {
    console.error("location: ".concat(e.fileName, ":").concat(e.lineNumber));
  }

  console.error("message: ".concat(e.message));
  console.error("stack: ".concat(e.stack));

  if (serverSide) {
    msg += "Exception in rendering!\n".concat(e.fileName ? "\nlocation: ".concat(e.fileName, ":").concat(e.lineNumber) : '', "\nMessage: ").concat(e.message, "\n\n").concat(e.stack);

    var reactElement = _react["default"].createElement('pre', null, msg);

    return _server["default"].renderToString(reactElement);
  }

  return undefined;
};

var _default = handleError;
exports["default"] = _default;